import React from 'react';
import Modal from '../Modal';
import DeleteComponent from './DeleteComponent.jsx';

const DeleteModal = ({ phrases, onConfirm, onCancel }) => {
  return Modal({
    component: (
      <DeleteComponent
        phrases={phrases}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    ),
    width: '394px',
    padding: '24px',
  });
};

export default DeleteModal;
